import { commonInitMenu } from "../utils/commonInitMenu";
import {
  kSARightClickCmds,
  kSARightClickIcons,
  kSARightClickOptions,
  kCanvasRightClickWidth
} from "../constants";
import { QIconDropDown } from "./QIconDropDown";

export class QSARightClick extends QIconDropDown {
  constructor() {
    super();
  }

  InitMenu(baseCode, wsMgr, x, y) {
    commonInitMenu(this, wsMgr, kSARightClickOptions.length, x, y);
    this.InitIconDropDown(
      baseCode,
      wsMgr,
      kSARightClickOptions,
      null,
      kSARightClickCmds,
      kSARightClickIcons,
      true,
      kCanvasRightClickWidth
    );
  }
}
